/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star-full': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M21.523 9.97c.433-.44.585-1.087.399-1.688a1.588 1.588 0 00-1.274-1.12l-5.327-.809a.699.699 0 01-.524-.398L12.415.918A1.563 1.563 0 0011 0c-.604 0-1.147.352-1.414.918L7.204 5.956a.7.7 0 01-.525.398l-5.327.808c-.598.09-1.086.52-1.274 1.12a1.687 1.687 0 00.4 1.688l3.854 3.922c.164.167.24.408.2.643l-.909 5.537c-.08.488.042.962.344 1.336.47.582 1.29.76 1.945.4l4.764-2.614c.2-.11.45-.108.648 0l4.765 2.614c.231.128.479.192.734.192.465 0 .907-.216 1.21-.592.303-.374.425-.849.344-1.336l-.91-5.537a.748.748 0 01.201-.643l3.855-3.922z" _fill="#F0CD5C" fill-rule="evenodd"/>'
  }
})
